import React from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";

import { Carousel } from "react-bootstrap";
import dhl from "../../assets/video/video-vitrine-dhl.mp4";
import ouro from "../../assets/video/video-vitrine-ouro.mp4";
import cambio from "../../assets/video/video-vitrine-cambio.mp4";
import global from "../../assets/video/video-vitrine-global.mp4";
export default function VitrineModelo({BoxTable}) {
  return (
    <Container>
      <Carousel
        controls={true}
        indicators={true}
        className="carousel-vitrine"
        pause={false}
      >
        <Carousel.Item interval={15000}>
          <BoxTable/>
        </Carousel.Item>
        <Carousel.Item interval={25000}>
          <BoxVideo>
            <ReactPlayer
              url={cambio}
              playing
              loop
              controls
              muted
              width="100vw"
              height="100vh"
            />
          </BoxVideo>
        </Carousel.Item>
        <Carousel.Item interval={15000}>
          <BoxTable/>
        </Carousel.Item>
        <Carousel.Item interval={25000}>
          <BoxVideo>
            <ReactPlayer
              url={ouro}
              playing
              loop
              controls
              muted
              width="100vw"
              height="100vh"
            />
          </BoxVideo>
        </Carousel.Item>

        <Carousel.Item interval={15000}>
          <BoxTable/>
        </Carousel.Item>
        <Carousel.Item interval={25000}>
          <BoxVideo>
            <ReactPlayer
              url={dhl}
              playing
              loop
              controls
              muted
              width="100vw"
              height="100vh"
            />
          </BoxVideo>
        </Carousel.Item>
        <Carousel.Item interval={15000}>
          <BoxTable/>
        </Carousel.Item>

        <Carousel.Item interval={45000}>
          <BoxVideo>
            <ReactPlayer
              url={global}
              playing
              loop
              controls
              muted
              width="100vw"
              height="100vh"
            />
          </BoxVideo>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

const Container = styled.div`
  margin: 0 auto;
  height: 80vh;
`;

const BoxVideo = styled.div`
  display: flex;
  justify-content: center;
`;
